module.exports = __webpack_public_path__ + "img/invite-member.fde55c6d.png";